import styled from '@emotion/styled';
import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  TextField,
} from '@mui/material';
import useDownloadCardex from 'api/cardex/useDownloadCardex';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';

export const CartexToolbar = props => {
  const {
    searchedZones,
    selectedZone,
    searchedBranches,
    selectedBranch,
    setSelectedZone,
    setSelectedBranch,
  } = props;

  const [downloadCardex, downloadCardexLoading] = useDownloadCardex();
  const { enqueueSnackbar } = useSnackbar();

  return (
    <Box>
      <HeaderWrapper>
        <ContentWrapper>
          <Content>
            <div style={{ width: '320px' }}>
              <Autocomplete
                options={searchedZones || []}
                autoHighlight
                value={selectedZone || null}
                getOptionLabel={option => option.value}
                noOptionsText={
                  <div className="w-full flex justify-center">
                    موردی یافت نشد
                  </div>
                }
                renderOption={(args, option) => (
                  <div {...args} dir="rtl">
                    {option.value}
                  </div>
                )}
                onChange={(event, newValue) => {
                  setSelectedZone(prev => newValue);
                }}
                sx={{
                  '.MuiInputBase-root': {
                    paddingRight: '9px !important',
                  },
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    sx={{
                      '.MuiAutocomplete-endAdornment': {
                        right: 'unset !important',
                        left: '9px',
                      },
                      '.MuiAutocomplete-endAdornment button': {
                        mr: 0.5,
                      },
                    }}
                    label="انتخاب انبار"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'zone', // disable autocomplete and autofill
                    }}
                    className="gray-icon"
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                )}
              />
            </div>
            <div style={{ width: '320px' }}>
              <Autocomplete
                options={searchedBranches || []}
                autoHighlight
                value={selectedBranch || null}
                getOptionLabel={option => option.value}
                noOptionsText={
                  <div className="w-full flex justify-center">
                    موردی یافت نشد
                  </div>
                }
                renderOption={(args, option) => (
                  <div {...args} dir="rtl">
                    {option.value}
                  </div>
                )}
                onChange={(event, newValue) => {
                  setSelectedBranch(prev => newValue);
                }}
                sx={{
                  '.MuiInputBase-root': {
                    paddingRight: '9px !important',
                  },
                }}
                renderInput={params => (
                  <TextField
                    {...params}
                    sx={{
                      '.MuiAutocomplete-endAdornment': {
                        right: 'unset !important',
                        left: '9px',
                      },
                      '.MuiAutocomplete-endAdornment button': {
                        mr: 0.5,
                      },
                    }}
                    label="انتخاب برنچ"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'zone', // disable autocomplete and autofill
                    }}
                    className="gray-icon"
                    InputProps={{
                      ...params.InputProps,
                    }}
                  />
                )}
              />
            </div>
          </Content>
          <div
            style={{
              flexDirection: 'row',
              display: 'flex',
              gap: 2,
              justifyContent: 'flex-end',
            }}
          >
            {props.addLable ? (
              <div>
                <AddBtn
                  sx={{ width: '140px' }}
                  variant="contained"
                  onClick={() =>
                    props.submitCartex({
                      zoneGuid: selectedZone?.key,
                      branchGuid: selectedBranch?.key,
                    })
                  }
                >
                  {props.addLable}
                </AddBtn>
              </div>
            ) : null}
            <div>
              <AddBtn
                variant="contained"
                sx={{ width: '140px' }}
                onClick={() => {
                  if (!!selectedZone || !!selectedBranch) {
                    downloadCardex({
                      zoneGuid: selectedZone?.key,
                      branchGuid: selectedBranch?.key,
                      selectedBranch: selectedZone?.value,
                      selectedZone: selectedBranch?.value,
                    });
                  } else {
                    enqueueSnackbar('لطفا ابتدا انبار را انتخاب کنید', {
                      variant: 'error',
                    });
                  }
                }}
              >
                {'دانلود کاردکس'}
              </AddBtn>
            </div>
          </div>
        </ContentWrapper>
        <form />
      </HeaderWrapper>
    </Box>
  );
};

const Container = styled(Box)`
  ${({ theme }) => ({
    p: 2,
    pb: 0,
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  })}
`;

const HeaderWrapper = styled(Box)`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 10px;
  margin: 1.5rem 0 1rem 0;

  @media all and (max-width: 600px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    margin-top: 15px;
    padding-right: 10px;
  }
`;

const ContentWrapper = styled(Box)`
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: space-between;

  @media all and (max-width: 1350px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

const Content = styled(Box)`
  flex-direction: row;
  display: flex;
  gap: 12px;
  justify-content: flex-start;

  @media all and (max-width: 1000px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const AddBtn = styled(Button)`
  margin-left: 10px;
  background-color: #27348b;
`;
